import { render, staticRenderFns } from "./ContractStatusDetail.vue?vue&type=template&id=765cb5b9&"
import script from "./ContractStatusDetail.vue?vue&type=script&lang=js&"
export * from "./ContractStatusDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports